import {
  MenuItem,
  Select as MUISelect,
  SelectChangeEvent,
} from '@mui/material';
import { FormFieldData } from '../../../constants/types';
import { FocusEventHandler } from 'react';

interface ISelect {
  value: string;
  formFieldData: FormFieldData;
  handleBlur: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  handleSelectChange: (event: SelectChangeEvent) => void;
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const Select: React.FC<ISelect> = ({
  value,
  formFieldData,
  handleBlur,
  handleSelectChange,
  handleKeyDown,
}) => {
  const { id, name, placeholder, options } = formFieldData;

  return (
    <MUISelect
      id={id}
      name={name}
      placeholder={placeholder}
      value={value as string}
      displayEmpty
      inputProps={{ 'aria-label': 'Without label' }}
      sx={{ mb: 2 }}
      onChange={handleSelectChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
    >
      <MenuItem disabled value="">
        {placeholder}
      </MenuItem>
      {options?.map((option: { value: string | number; label: string }) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </MUISelect>
  );
};

export default Select;
